// DASH-2690 (G11v2): lifecycle of the parent SamplingPlan aggregate. Ordering MUST mirror the BE
// Web.Api.Core/Domain/Enums/SamplingPlanStatusEnum.cs (Draft=0, Submitted=1, Approved=2, Rejected=3) so the
// numeric status coming back from GetList maps to the right label/badge.
export enum SamplingPlanStatus {
    Draft = 0,
    Submitted = 1,
    Approved = 2,
    Rejected = 3,
}
